import React, { useEffect, useState } from 'react'
import { Form, Row, Col, FloatingLabel } from 'react-bootstrap';
import { PatternFormat } from 'react-number-format';

export default function BillingAddress({uniqueId, sendAddressDataToParent , isLoaderRunning}) {

  //field validation state:
  const [addressInvalidMessage, setAddressInvalidMessage] = useState('');
  const [postalCodeInvalidMessage, setPostalCodeInvalidMessage] = useState('');
  const [emailInvalidMessage, setEmailInvalidMessage] = useState('');

  //data object state:
  let addressObject = { address1: "", address2: "", city: "", state: "", postalCode: "", country: "US", email: "", receiptEmails: "" };
  const [addressData, setAddressData] = useState(addressObject);

  //Address blur effect:
  const handleBlurOnAddress = () => {
    let inputAddress = addressData.address1.trim();

    if (inputAddress === '') {
      setAddressInvalidMessage('Address is required');
    }
  }
  //Postalcode blur effect:
  const handleBlurOnPostalCode = () => {
    let inputPostalCode = addressData.postalCode.trim();

    if (inputPostalCode === '') {
      setPostalCodeInvalidMessage('PostalCode is required')
    }
    if (inputPostalCode.length > 0 && inputPostalCode.length < 5) {
      setPostalCodeInvalidMessage('PostalCode is invalid')
    }
  }

  //Email blur effect:
  const handleBlurOnEmail = () => {
    let inputEmail = addressData.email.trim();
    let inputEmailMatch = inputEmail.match(new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/));

    if(inputEmail === ''){
      setEmailInvalidMessage('Email is required.');
    }

    if (inputEmail.length > 0 && !inputEmailMatch) {
      setEmailInvalidMessage('Email is invalid')
    }
  }

  //Handle change input effect:
  const handleAddressChangeInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === 'address1') {
      setAddressInvalidMessage('');
    }
    if (name === 'postalCode') {
      setPostalCodeInvalidMessage('');
    }
    if (name === 'email') {
      setEmailInvalidMessage('');
    }
    if (name === 'country') {
      addressData.state = '';
    }

    setAddressData({ ...addressData, [name]: value });
  };

  //Send data to card/echeck component:
  useEffect(() => {
    sendAddressDataToParent(addressData);
  }, [addressData, sendAddressDataToParent])


  return (
    <>
      <h3 className="accordion-title mt-3">Billing Address</h3>
      <Row className="gx-2">

        <Form.Group as={Col} xs={12} controlId={`floatingAddress-${uniqueId}`}>
          <FloatingLabel controlId={`floatingAddress-${uniqueId}`}
            label={
              <span className={addressInvalidMessage ? 'text-danger' : ''}>
                {addressInvalidMessage ? addressInvalidMessage : "Address"}
              </span>
            }
            className="mb-2">
            <Form.Control
              type="text"
              placeholder="Address"
              className={addressInvalidMessage ? 'border-danger' : ''}
              name='address1'
              value={addressData.address1}
              disabled={isLoaderRunning}
              onBlur={handleBlurOnAddress}
              onChange={handleAddressChangeInput}
            // required
            />
          </FloatingLabel>
        </Form.Group>

        <Form.Group as={Col} xs={12} controlId={`floatingAddress2-${uniqueId}`}>
          <FloatingLabel controlId={`floatingAddress2-${uniqueId}`} label="Address 2 (Optional)" className="mb-2">
            <Form.Control 
            type="text" 
            placeholder="Address 2 (Optional)"
            name='address2' 
            value={addressData.address2}
            disabled={isLoaderRunning}
            onChange={handleAddressChangeInput} />
          </FloatingLabel>
        </Form.Group>

        <Form.Group as={Col} xl={6} controlId={`floatingCity-${uniqueId}`}>
          <FloatingLabel controlId={`floatingCity-${uniqueId}`} label="City" className="mb-2">
            <Form.Control type="text" placeholder="City" name='city' value={addressData.city} disabled={isLoaderRunning} onChange={handleAddressChangeInput} />
          </FloatingLabel>
        </Form.Group>

        <Form.Group as={Col} xl={6} controlId={`floatingState-${uniqueId}`}>
          <FloatingLabel controlId={`floatingState-${uniqueId}`}
            // label={addressData.country === 'US' ? "State" : (addressData.country === 'CA' ? "Province" : "State/Province")}
            label="State"
            className="mb-2">

            {/* USA */}
            {/* {addressData.country === 'US' ? */}


              <Form.Select aria-label="Floating label select" name='state' value={addressData.state} disabled={isLoaderRunning} onChange={handleAddressChangeInput}>
                <option value="">Select</option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="AA">Armed Forces Americas</option>
                <option value="AE">Armed Forces Europe</option>
                <option value="AP">Armed Forces Pacific</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="PR">Puerto Rico</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </Form.Select> 
              {/* // CANADA:
              (addressData.country === 'CA' ?
                <Form.Select aria-label="Floating label select" name='state' value={addressData.state} onChange={handleAddressChangeInput}>
                  <option value="">Select</option>
                  <option value="AB">Alberta</option>
                  <option value="BC">British Columbia</option>
                  <option value="MB">Manitoba</option>
                  <option value="NB">New Brunswick</option>
                  <option value="NL">Newfoundland and Labrador</option>
                  <option value="NS">Nova Scotia</option>
                  <option value="ON">Ontario</option>
                  <option value="PE">Prince Edward Island</option>
                  <option value="QC">Quebec</option>
                  <option value="SK">Saskatchewan</option>
                  <option value="NT">Northwest Territories</option>
                  <option value="NU">Nunavut</option>
                  <option value="YT">Yukon</option>
                </Form.Select> :
                //ALL COUNTRY:
                <Form.Control type="text" placeholder="State" name='state' value={addressData.state} onChange={handleAddressChangeInput} /> */}
              {/* )} */}
          </FloatingLabel>
        </Form.Group>

        <Form.Group as={Col} xl={6} controlId={`floatingPostal-${uniqueId}`}>
          <FloatingLabel controlId={`floatingPostal-${uniqueId}`}
            label={
              <span className={postalCodeInvalidMessage ? 'text-danger' : ''}>
                {postalCodeInvalidMessage ? postalCodeInvalidMessage : "Postal Code"}
              </span>
            }
            className="mb-2">
            <PatternFormat
              format="#####"
              mask=""
              id={`floatingPostal-${uniqueId}`}
              className={`form-control ${postalCodeInvalidMessage ? 'border-danger' : ''}`}
              placeholder="Postal Code"
              name='postalCode'
              value={addressData.postalCode}
              disabled={isLoaderRunning}
              onBlur={handleBlurOnPostalCode}
              onChange={handleAddressChangeInput}
            // required
            />
          </FloatingLabel>
        </Form.Group>

        <Form.Group as={Col} xl={6} controlId={`floatingCountry-${uniqueId}`}>
          <FloatingLabel controlId={`floatingCountry-${uniqueId}`} label="Country" className="mb-2">
            {/* add country */}
            <Form.Select required aria-label="Floating label select" name='country' value={addressData.country}
            disabled={isLoaderRunning}
            onChange={handleAddressChangeInput}>
              <option value="US">United States</option>
              {/* <option value="CA">Canada</option>
              <option value="AF">Afghanistan</option>
              <option value="AX">Åland Islands</option>
              <option value="AL">Albania</option>
              <option value="DZ">Algeria</option>
              <option value="AS">American Samoa</option>
              <option value="AD">Andorra</option>
              <option value="AO">Angola</option>
              <option value="AI">Anguilla</option>
              <option value="AQ">Antarctica</option>
              <option value="AG">Antigua and Barbuda</option>
              <option value="AR">Argentina</option>
              <option value="AM">Armenia</option>
              <option value="AW">Aruba</option>
              <option value="AU">Australia</option>
              <option value="AT">Austria</option>
              <option value="AZ">Azerbaijan</option>
              <option value="BS">Bahamas</option>
              <option value="BH">Bahrain</option>
              <option value="BD">Bangladesh</option>
              <option value="BB">Barbados</option>
              <option value="BY">Belarus</option>
              <option value="BE">Belgium</option>
              <option value="BZ">Belize</option>
              <option value="BJ">Benin</option>
              <option value="BM">Bermuda</option>
              <option value="BT">Bhutan</option>
              <option value="BO">Bolivia</option>
              <option value="BA">Bosnia and Herzegovina</option>
              <option value="BW">Botswana</option>
              <option value="BV">Bouvet Island</option>
              <option value="BR">Brazil</option>
              <option value="UK">Britain (UK)</option>
              <option value="IO">British Indian Ocean Territory</option>
              <option value="BN">Brunei Darussalam</option>
              <option value="BG">Bulgaria</option>
              <option value="BF">Burkina Faso</option>
              <option value="BI">Burundi</option>
              <option value="KH">Cambodia</option>
              <option value="CM">Cameroon</option>
              <option value="CV">Cape Verde</option>
              <option value="KY">Cayman Islands</option>
              <option value="CF">Central African Republic</option>
              <option value="TD">Chad</option>
              <option value="CL">Chile</option>
              <option value="CN">China</option>
              <option value="CX">Christmas Island</option>
              <option value="CC">Cocos (Keeling) Islands</option>
              <option value="CO">Colombia</option>
              <option value="KM">Comoros</option>
              <option value="CG">Congo</option>
              <option value="CD">The Democratic Republic of the Congo</option>
              <option value="CK">Cook Islands</option>
              <option value="CR">Costa Rica</option>
              <option value="CI">Cote D'Ivoire</option>
              <option value="HR">Croatia</option>
              <option value="CU">Cuba</option>
              <option value="CY">Cyprus</option>
              <option value="CZ">Czech Republic</option>
              <option value="DK">Denmark</option>
              <option value="DJ">Djibouti</option>
              <option value="DM">Dominica</option>
              <option value="DO">Dominican Republic</option>
              <option value="EC">Ecuador</option>
              <option value="EG">Egypt</option>
              <option value="SV">El Salvador</option>
              <option value="GQ">Equatorial Guinea</option>
              <option value="ER">Eritrea</option>
              <option value="EE">Estonia</option>
              <option value="ET">Ethiopia</option>
              <option value="FK">Falkland Islands (Malvinas)</option>
              <option value="FO">Faroe Islands</option>
              <option value="FJ">Fiji</option>
              <option value="FI">Finland</option>
              <option value="FR">France</option>
              <option value="GF">French Guiana</option>
              <option value="PF">French Polynesia</option>
              <option value="TF">French Southern Territories</option>
              <option value="GA">Gabon</option>
              <option value="GM">Gambia</option>
              <option value="GE">Georgia</option>
              <option value="DE">Germany</option>
              <option value="GH">Ghana</option>
              <option value="GI">Gibraltar</option>
              <option value="GR">Greece</option>
              <option value="GL">Greenland</option>
              <option value="GD">Grenada</option>
              <option value="GP">Guadeloupe</option>
              <option value="GU">Guam</option>
              <option value="GT">Guatemala</option>
              <option value="GG">Guernsey</option>
              <option value="GN">Guinea</option>
              <option value="GW">Guinea-Bissau</option>
              <option value="GY">Guyana</option>
              <option value="HT">Haiti</option>
              <option value="HM">Heard Island and Mcdonald Islands</option>
              <option value="VA">Holy See (Vatican City State)</option>
              <option value="HN">Honduras</option>
              <option value="HK">Hong Kong</option>
              <option value="HU">Hungary</option>
              <option value="IS">Iceland</option>
              <option value="IN">India</option>
              <option value="ID">Indonesia</option>
              <option value="IR">Islamic Republic Of Iran</option>
              <option value="IQ">Iraq</option>
              <option value="IE">Ireland</option>
              <option value="IM">Isle of Man</option>
              <option value="IL">Israel</option>
              <option value="IT">Italy</option>
              <option value="JM">Jamaica</option>
              <option value="JP">Japan</option>
              <option value="JE">Jersey</option>
              <option value="JO">Jordan</option>
              <option value="KZ">Kazakhstan</option>
              <option value="KE">Kenya</option>
              <option value="KI">Kiribati</option>
              <option value="KP">Democratic People's Republic of Korea</option>
              <option value="KR">Republic of Korea</option>
              <option value="KW">Kuwait</option>
              <option value="KG">Kyrgyzstan</option>
              <option value="LA">Lao People's Democratic Republic</option>
              <option value="LV">Latvia</option>
              <option value="LB">Lebanon</option>
              <option value="LS">Lesotho</option>
              <option value="LR">Liberia</option>
              <option value="LY">Libyan Arab Jamahiriya</option>
              <option value="LI">Liechtenstein</option>
              <option value="LT">Lithuania</option>
              <option value="LU">Luxembourg</option>
              <option value="MO">Macao</option>
              <option value="MK">The Former Yugoslav Republic of Macedonia</option>
              <option value="MG">Madagascar</option>
              <option value="MW">Malawi</option>
              <option value="MY">Malaysia</option>
              <option value="MV">Maldives</option>
              <option value="ML">Mali</option>
              <option value="MT">Malta</option>
              <option value="MH">Marshall Islands</option>
              <option value="MQ">Martinique</option>
              <option value="MR">Mauritania</option>
              <option value="MU">Mauritius</option>
              <option value="YT">Mayotte</option>
              <option value="MX">Mexico</option>
              <option value="FM">Federated States of Micronesia</option>
              <option value="MD">Republic of Moldova</option>
              <option value="MC">Monaco</option>
              <option value="MN">Mongolia</option>
              <option value="MS">Montserrat</option>
              <option value="MA">Morocco</option>
              <option value="MZ">Mozambique</option>
              <option value="MM">Myanmar</option>
              <option value="NA">Namibia</option>
              <option value="NR">Nauru</option>
              <option value="NP">Nepal</option>
              <option value="NL">Netherlands</option>
              <option value="AN">Netherlands Antilles</option>
              <option value="NC">New Caledonia</option>
              <option value="NZ">New Zealand</option>
              <option value="NI">Nicaragua</option>
              <option value="NE">Niger</option>
              <option value="NG">Nigeria</option>
              <option value="NU">Niue</option>
              <option value="NF">Norfolk Island</option>
              <option value="MP">Northern Mariana Islands</option>
              <option value="NO">Norway</option>
              <option value="OM">Oman</option>
              <option value="PK">Pakistan</option>
              <option value="PW">Palau</option>
              <option value="PS">Occupied Palestinian Territory</option>
              <option value="PA">Panama</option>
              <option value="PG">Papua New Guinea</option>
              <option value="PY">Paraguay</option>
              <option value="PE">Peru</option>
              <option value="PH">Philippines</option>
              <option value="PN">Pitcairn</option>
              <option value="PL">Poland</option>
              <option value="PT">Portugal</option>
              <option value="QA">Qatar</option>
              <option value="RE">Reunion</option>
              <option value="RO">Romania</option>
              <option value="RU">Russian Federation</option>
              <option value="RW">RWANDA</option>
              <option value="SH">Saint Helena</option>
              <option value="KN">Saint Kitts and Nevis</option>
              <option value="LC">Saint Lucia</option>
              <option value="PM">Saint Pierre and Miquelon</option>
              <option value="VC">Saint Vincent and the Grenadines</option>
              <option value="WS">Samoa</option>
              <option value="SM">San Marino</option>
              <option value="ST">Sao Tome and Principe</option>
              <option value="SA">Saudi Arabia</option>
              <option value="SN">Senegal</option>
              <option value="CS">Serbia and Montenegro</option>
              <option value="SC">Seychelles</option>
              <option value="SL">Sierra Leone</option>
              <option value="SG">Singapore</option>
              <option value="SK">Slovakia</option>
              <option value="SI">Slovenia</option>
              <option value="SB">Solomon Islands</option>
              <option value="SO">Somalia</option>
              <option value="ZA">South Africa</option>
              <option value="GS">South Georgia and the South Sandwich Islands</option>
              <option value="ES">Spain</option>
              <option value="LK">Sri Lanka</option>
              <option value="SD">Sudan</option>
              <option value="SR">Suriname</option>
              <option value="SJ">Svalbard and Jan Mayen</option>
              <option value="SZ">Swaziland</option>
              <option value="SE">Sweden</option>
              <option value="CH">Switzerland</option>
              <option value="SY">Syrian Arab Republic</option>
              <option value="TW">Province of China Taiwan</option>
              <option value="TJ">Tajikistan</option>
              <option value="TZ">United Republic of Tanzania</option>
              <option value="TH">Thailand</option>
              <option value="TL">Timor-Leste</option>
              <option value="TG">Togo</option>
              <option value="TK">Tokelau</option>
              <option value="TO">Tonga</option>
              <option value="TT">Trinidad and Tobago</option>
              <option value="TN">Tunisia</option>
              <option value="TR">Turkey</option>
              <option value="TM">Turkmenistan</option>
              <option value="TC">Turks and Caicos Islands</option>
              <option value="TV">Tuvalu</option>
              <option value="UG">Uganda</option>
              <option value="UA">Ukraine</option>
              <option value="AE">United Arab Emirates</option>
              <option value="GB">United Kingdom</option>
              <option value="UM">United States Minor Outlying Islands</option>
              <option value="UY">Uruguay</option>
              <option value="UZ">Uzbekistan</option>
              <option value="VU">Vanuatu</option>
              <option value="VE">Venezuela</option>
              <option value="VN">Vietnam</option>
              <option value="VG">British Virgin Islands</option>
              <option value="VI">U.S. Virgin Islands</option>
              <option value="WF">Wallis and Futuna</option>
              <option value="EH">Western Sahara</option>
              <option value="YE">Yemen</option>
              <option value="ZM">Zambia</option>
              <option value="ZW">Zimbabwe</option> */}
            </Form.Select>
          </FloatingLabel>
        </Form.Group>
        
        
        <Form.Group as={Col} xs={12} controlId={`floatingReceiptemail-${uniqueId}`}>
          <FloatingLabel controlId={`floatingReceiptemail-${uniqueId}`}
            label={
              <span className={emailInvalidMessage ? 'text-danger' : ''}>
                {emailInvalidMessage ? emailInvalidMessage : "Email"}
              </span>
            }
            className="mb-2">
            <Form.Control
              type="text" placeholder="Email" name='email'
              className={`${emailInvalidMessage ? 'border-danger' : ''}`}
              value={addressData.email}
              disabled={isLoaderRunning}
              onBlur={handleBlurOnEmail}
              onChange={handleAddressChangeInput} />
          </FloatingLabel>
        </Form.Group>

        <Form.Group as={Col} xs={12} controlId={`floatingReceiptemail-${uniqueId}`}>
          <FloatingLabel controlId={`floatingReceiptemail-${uniqueId}`}
            label="Additional Receipt Emails (Optional)"
            className="mb-0">
            <Form.Control
              type="text" placeholder="Additional Receipt Emails (Optional)" name='receiptEmails'
              value={addressData.receiptEmails}
              disabled={isLoaderRunning}
              // onBlur={handleBlurOnEmail}
              onChange={handleAddressChangeInput} />
          </FloatingLabel>
          <Row className="mt-0">
            <Col >
            <p style={{ fontSize: '12px', fontWeight: '400', color: '#666', lineHeight: '16px', fontStyle: 'italic'}}>
             <strong>Note:</strong> You can enter multiple email addresses separated by commas (e.g., name1@example.com, name2@example.com).
            </p>
            </Col>
          </Row>
        </Form.Group>



      </Row>
    </>
  )
}
